import { all, call, put } from 'redux-saga/effects';

import { getConversionToolColumns, getMapping } from '@api/mapping';
import { intl } from '@helpers/intl';
import { conversionToolInitialValuesModel } from '@models/ConversionTool/conversionInitialValues';
import { conversionToolColumnsGetModel } from '@models/ConversionTool/conversionToolColumnsGet';
import { conversionToolMappingEditModel } from '@models/ConversionTool/conversionToolMappingEdit';
import {
  conversionToolMappingFetchFailureAction,
  conversionToolMappingFetchSuccessAction,
} from '@store/conversionTool/conversionToolMappingEdit/conversionToolMappingEdit.actions';

export const conversionToolMappingFetchSaga = function* ({ payload = '' }) {
  try {
    const [response, columnsResponse] = yield all([
      call(getMapping, payload),
      call(getConversionToolColumns, {}),
    ]);
    const columns = yield call(conversionToolColumnsGetModel, columnsResponse.columns);
    const { columnMap: mapping, ...rest } = response;

    yield put(
      conversionToolMappingFetchSuccessAction({
        mapping: {
          columnMap: conversionToolMappingEditModel(
            mapping,
            conversionToolInitialValuesModel(columns)
          ),
          ...rest,
        },
        fields: columns,
      })
    );
  } catch (errors) {
    const { nonFieldErrors } = errors?.data || {};

    const errorMessage =
      nonFieldErrors ||
      intl.formatMessage({
        id: 'components.mapping-edit-page.api-fetch-error',
        defaultMessage: 'Failed to fetch mapping.',
      });

    yield put(conversionToolMappingFetchFailureAction({ errorMessage }));
  }
};
